import initialState from './initialState';
import Immutable from 'immutable';
import createReducer from './createReducer';
import { findInParams } from '../utils/userManager';

const setSearchProperty = (state, action) => {
    return state.setIn([
        'techSearch', 'searchCriteria'
    ], action.searchId);
};

const setTransferToProperty = (state, action) => {
    return state.setIn([
        'techSearch', 'transferToTechId'
    ], action.toTechId);
};

const setTechInfoLoadStarted = (state) => {
    return state.setIn([
        'techSearch', 'searchLoading'
    ], true).setIn([
        'techSearch', 'searchFinished'
    ], false).setIn([
        'techSearch', 'topMatch'
    ], null).setIn([
        'inventoryTransfer', 'error'
    ], null).setIn([
        'inventoryTransfer', 'message'
    ], null);
};

const setTechInfoFinished = (state, action) => {
    return state.setIn([
        'techSearch', 'searchLoading'
    ], false).setIn([
        'techSearch', 'searchFinished'
    ], true).setIn([
        'techSearch', 'topMatch'
    ], action.payload[0].userId).setIn([
        'techSearch', 'techSearchResults', action.payload[0].userId, 'lastSearched'
    ], new Date()).setIn([
        'techs', action.payload[0].userId, 'info'
    ], Immutable.fromJS(action.payload[0]));
};

const setTopMatch = (state, action) => {
    return state.setIn([
        'techSearch', 'topMatch'
    ], action.userId);
};

const handleTechInfoLoadFailed = (state, action) => {
    return state.setIn([
        'techSearch', 'searchLoading'
    ], false).setIn([
        'techSearch', 'searchFinished'
    ], true).setIn([
        'techSearch', 'topMatch'
    ], null).setIn([
        'techSearch', 'error'
    ], Immutable.fromJS(action.payload.message));
};

const setStatusLoading = (state, action) => {
    return state.setIn([
        'techs', action.userId, 'statusLoading'
    ], true).setIn([
        'techs', action.userId, 'statusWaiting'
    ], true).setIn([
        'techs', action.userId, 'statusLoadingFinished'
    ], false).setIn([
        'techs', action.userId, 'statusLoadingStartedTime'
    ], action.timestamp);
};

const setTechStatusWaiting = (state, action) => {

    if (!action.userId) {
        return state;
    } else {
        if (state.getIn(['techs', action.userId, 'statusLoadingFinished'])) {
            return state;
        } else {
            return state.setIn([
                'techs', action.userId, 'statusLoading'
            ], true).setIn([
                'techs', action.userId, 'statusWaiting'
            ], true).setIn([
                'techs', action.userId, 'statusLoadingFinished'
            ], false);
        }
    }
};

const setGetTechStatusStarted = (state, action) => {
    if (!action.userId) {
        return state;
    } else {
        return state.setIn([
            'techs', action.userId, 'statusLoading'
        ], true).setIn([
            'techs', action.userId, 'statusWaiting'
        ], true);
    }
};

const setGetTechStatusFinished = (state, action) => {
    if (!action.userId) {
        return state;
    } else {
        return state.setIn([
            'techs', action.userId, 'status'
        ], Immutable.fromJS(action.payload)).setIn([
            'techs', action.userId, 'statusLoading'
        ], false).setIn([
            'techs', action.userId, 'statusWaiting'
        ], false).setIn([
            'techs', action.userId, 'statusLoadingFinished'
        ], true).setIn([
            'techs', action.userId, 'statusLoadingError'
        ], null).setIn([
            'techs', action.userId, 'statusLoadedTime'
        ], action.timestamp);
    }
};

const setGetTechStatusFailed = (state, action) => {
    if (!action.userId) {
        return state;
    } else {
        return state.setIn([
            'techs', action.userId, 'statusLoading'
        ], false).setIn([
            'techs', action.userId, 'statusWaiting'
        ], false).setIn([
            'techs', action.userId, 'statusLoadingFinished'
        ], true).setIn([
            'techs', action.userId, 'statusLoadingError'
        ], 'Failed to Get Status');
    }
};

const techStatusSetFinished = (state, action) => {
    if (!action.userId) {
        return state;
    } else {
        return hideArrivalDialog(state, action)
            .setIn([
                'techs', action.userId, 'status'
            ], Immutable.fromJS(action.payload.originalPayload))
            .setIn([
                'techs', action.userId, 'statusLoading'
            ], false).setIn([
                'techs', action.userId, 'statusWaiting'
            ], false).setIn([
                'techs', action.userId, 'statusLoadingFinished'
            ], true).setIn([
                'techs', action.userId, 'statusLoadingError'
            ], null).setIn([
                'techs', action.userId, 'statusLoadedTime'
            ], action.timestamp);
    }
};

const techStatusSetFailed = (state, action) => {

    return hideArrivalDialog(state, action).setIn([
        'techs', action.userId, 'statusLoading'
    ], false).setIn([
        'techs', action.userId, 'statusWaiting'
    ], false).setIn([
        'techs', action.userId, 'statusLoadingFinished'
    ], true).setIn([
        'techs', action.userId, 'statusLoadingError'
    ], 'Failed to Set Status');
};

const getTechRouteStarted = (state, action) => {
    return state.setIn([
        'techs', action.request.userId, 'workOrderLoading'
    ], true).setIn([
        'techs', action.request.userId, 'workOrderLoadingFinished'
    ], false).setIn([
        'techs', action.request.userId, 'routeLoadedTime'
    ], new Date()).setIn([
        'techs', action.request.userId, 'assignedServiceOrders'
    ], new Immutable.List()).setIn([
        'techs', action.request.userId, 'workOrderLoadingError'
    ], '');
};

const getTechRouteFinished = (state, action) => {
    const assignedServiceOrders = Immutable
        .fromJS(action.payload)
        .get('assignedServiceOrders');

    let assignedServiceOrderList = new Immutable.List();

    if (assignedServiceOrders) {

        const seenOrderIds = new Set();
        const dedupedAssignedServiceOrders = assignedServiceOrders.filter((item) => {
            const rawOrderId = item.getIn(['serviceOrderInfoV2', 'serviceOrderId']);
            if (rawOrderId === null || rawOrderId === undefined) {
                return false;
            }

            // Normalize to string so mixed numeric/string IDs collapse to one order.
            const normalizedOrderId = String(rawOrderId);
            if (seenOrderIds.has(normalizedOrderId)) {
                return false;
            }

            seenOrderIds.add(normalizedOrderId);
            return true;
        });

        const assignedServiceOrdersGroup = dedupedAssignedServiceOrders.groupBy((item) => {
            return item.get('technicianId');
        });

        assignedServiceOrdersGroup.forEach((items) => {
            let result = new Immutable.Map();

            result = result.set('techId', items.first().get('technicianId'));

            const orderIds = items.map((order) => {
                const orderId = order.getIn(['serviceOrderInfoV2', 'serviceOrderId']);
                return String(orderId);
            });

            const uniqueOrderIds = Immutable.List([...new Set(orderIds)]);
            result = result.set('orderIds', uniqueOrderIds);

            assignedServiceOrderList = assignedServiceOrderList.push(result);

        });

    }

    return state.setIn([
        'techs', action.userId, 'assignedServiceOrders'
    ], assignedServiceOrderList).setIn([
        'techs', action.userId, 'workOrderLoading'
    ], false).setIn([
        'techs', action.userId, 'workOrderLoadingFinished'
    ], true).setIn([
        'techs', action.userId, 'workOrderLoadingError'
    ], '');

};

const getTechRouteFailed = (state, action) => {
    return state.setIn([
        'techs', action.userId, 'workOrderLoading'
    ], false).setIn([
        'techs', action.userId, 'workOrderLoadingFinished'
    ], true).setIn([
        'techs', action.userId, 'workOrderLoadingError'
    ], 'Loading route failed');
};

const resetState = () => {
    return initialState.get('techData');
};

const rehydrate = (state, action) => {
    if (action.payload.techData) {
        state = action.payload.techData;
        // Reset status and route loading flags for all techs so a fresh fetch is always
        // triggered after a page load. Without this, a persisted statusLoadingFinished=true
        // (or workOrderLoadingFinished=true) suppresses the fetch and leaves stale data
        // (e.g. reassigned orders, or last session's route) displayed with no automatic refresh.
        const techs = state.get('techs');
        if (techs) {
            techs.keySeq().forEach(userId => {
                state = state
                    .setIn(['techs', userId, 'statusLoadingFinished'], false)
                    .setIn(['techs', userId, 'statusLoading'], false)
                    .setIn(['techs', userId, 'statusWaiting'], false)
                    .setIn(['techs', userId, 'workOrderLoadingFinished'], false)
                    .setIn(['techs', userId, 'workOrderLoading'], false);
            });
        }
    }
    return state.set('stateReady', true);
};

const setTechInfoFromToken = (state, action) => {
    const profile = action.payload && action.payload.profile;
    const username = profile && profile.preferred_username;
    const params = profile && profile.params;
    return state
        .setIn(['techs', username, 'info', 'userId'], username)
        .setIn(['techs', username, 'info', 'techId'], findInParams(params, 'tech_id'))
        .setIn(['techs', username, 'info', 'auxiliaryTechId'], findInParams(params, 'aux_tech_id'))
        // for the full onelogin structure see userManager.js
        ;
};

const setTechInventoryGetStarted = (state, action) => {
    return state.setIn([
        'techs', action.userId, 'inventory', 'loading'
    ], true).setIn([
        'techs', action.userId, 'inventory', 'loadingFinished'
    ], false);
};

const setTechInventoryGetFinished = (state, action) => {
    return state.setIn([
        'techs', action.userId, 'inventory', 'loading'
    ], false).setIn([
        'techs', action.userId, 'inventory', 'loadingFinished'
    ], true).setIn([
        'techs', action.userId, 'inventory', 'loadedTime'
    ], action.timestamp).setIn([
        'techs', action.userId, 'inventory', 'details'
    ], Immutable.fromJS(action.payload));
};

const setTechInventoryGetFailed = (state, action) => {
    return state.setIn([
        'techs', action.userId, 'inventory', 'loading'
    ], false).setIn([
        'techs', action.userId, 'inventory', 'loadingFinished'
    ], true).setIn([
        'techs', action.userId, 'inventory', 'loadedTime'
    ], action.timestamp).setIn([
        'techs', action.userId, 'inventory', 'error'
    ], 'Loading inventory failed');
};

const setInventorySearchStarted = (state) => {
    return state.setIn([
        'inventorySearch', 'loading'
    ], true).setIn([
        'inventorySearch', 'loadingFinished'
    ], false).setIn([
        'inventorySearch', 'error'
    ], null).setIn([
        'inventoryTransfer', 'error'
    ], null).setIn([
        'inventoryTransfer', 'message'
    ], null).setIn([
        'inventorySearch', 'details'
    ], null);
};

const setInventorySearchFinished = (state, action) => {
    return state.setIn([
        'inventorySearch', 'loading'
    ], false).setIn([
        'inventorySearch', 'loadingFinished'
    ], true).setIn([
        'inventorySearch', 'loadedTime'
    ], action.timestamp).setIn([
        'inventorySearch', 'details'
    ], Immutable.fromJS(action.payload));
};

const setInventorySearchFailed = (state, action) => {
    return state.setIn([
        'inventorySearch', 'loading'
    ], false).setIn([
        'inventorySearch', 'loadingFinished'
    ], true).setIn([
        'inventorySearch', 'loadedTime'
    ], action.timestamp).setIn([
        'inventorySearch', 'error'
    ], 'Search failed');
};

const setInventorySearchValue = (state, action) => {
    return state.setIn([
        'inventorySearch', 'searchValue'
    ], action.value).setIn([
        'inventorySearch', 'details'
    ], null);
};

const setArrivalTime = (state, action) => {
    return state.setIn([
        'techs', action.userId, 'arrivalTime', 'time'
    ], action.arrivalTime);

};

const setPubNubToken = (state, action) => {
    return state.setIn(['pubNubToken'], action.token);
};

const showArrivalDialog = (state, action) => {
    return state.setIn([
        'techs', action.userId, 'arrivalTime', 'show'
    ], true).setIn([
        'techs', action.userId, 'arrivalTime', 'orderId'
    ], action.firstWorkOrderNumber);
};

const hideArrivalDialog = (state, action) => {
    return state.setIn([
        'techs', action.userId, 'arrivalTime', 'show'
    ], false);
};

const setInventoryTransferStarted = (state) => {
    return state.setIn([
        'inventoryTransfer', 'loading'
    ], true).setIn([
        'inventoryTransfer', 'loadingFinished'
    ], false).setIn([
        'inventoryTransfer', 'error'
    ], null).setIn([
        'inventoryTransfer', 'message'
    ], 'Inventory Transfer Started');
};

const setInventoryTransferFinished = (state) => {
    return state.setIn([
        'inventoryTransfer', 'loading'
    ], false).setIn([
        'inventoryTransfer', 'loadingFinished'
    ], true).setIn([
        'inventoryTransfer', 'error'
    ], null).setIn([
        'inventoryTransfer', 'message'
    ], 'Inventory Transfer Succeeded');
};

const setInventoryTransferFailed = (state, error) => {
    let message = null;
    if (error.error.response.ErrorDescription) {
        message = error.error.response.ErrorDescription;
    }

    return state.setIn([
        'inventoryTransfer', 'loading'
    ], false).setIn([
        'inventoryTransfer', 'loadingFinished'
    ], true).setIn([
        'inventoryTransfer', 'error'
    ], Immutable.fromJS(message)).setIn([
        'inventoryTransfer', 'message'
    ], null);
};

const techHistoryRequestStarted = (state, action) => {
    return state.setIn([
        'techs', action.techId, 'history', 'loading'
    ], true).setIn([
        'techs', action.techId, 'history', 'loadingFinished'
    ], false).setIn([
        'techs', action.techId, 'history', 'isError'
    ], false).setIn([
        'techs', action.techId, 'history', 'error'
    ], null).setIn([
        'techs', action.techId, 'history', 'details'
    ], null);
};

const techHistoryRequestFinished = (state, action) => {
    return state.setIn([
        'techs', action.techId, 'history', 'loading'
    ], false).setIn([
        'techs', action.techId, 'history', 'loadingFinished'
    ], true).setIn([
        'techs', action.techId, 'history', 'isError'
    ], false).setIn([
        'techs', action.techId, 'history', 'error'
    ], null).setIn([
        'techs', action.techId, 'history', 'details'
    ], Immutable.fromJS(action.payload.fstTechOrderHistoryReportList));
};

const techHistoryRequestFailed = (state, action) => {
    return state.setIn([
        'techs', action.techId, 'history', 'loading'
    ], false).setIn([
        'techs', action.techId, 'history', 'loadingFinished'
    ], true).setIn([
        'techs', action.techId, 'history', 'isError'
    ], true).setIn([
        'techs', action.techId, 'history', 'error'
    ], Immutable.fromJS(action.payload)).setIn([
        'techs', action.techId, 'history', 'details'
    ], null);
};

const setTechHistoryTechId = (state, action) => {
    return state.setIn([
        'history', 'techId'
    ], action.techId);
};

const setTechHistoryStartDate = (state, action) => {
    return state.setIn([
        'history', 'startDate'
    ], action.startDate);
};

const setTechHistoryEndDate = (state, action) => {
    return state.setIn([
        'history', 'endDate'
    ], action.endDate);
};

const handlers = {
    'HIDE_ARRIVAL_TIME_DIALOG': hideArrivalDialog,
    'SHOW_ARRIVAL_TIME_DIALOG': showArrivalDialog,
    'GET_TECH_INFO_STARTED': setTechInfoLoadStarted,
    'GET_TECH_INFO_FINISHED': setTechInfoFinished,
    'GET_TECH_INFO_FAILED': handleTechInfoLoadFailed,
    'GET_TECH_STATUS_STARTED': setGetTechStatusStarted,
    'GET_TECH_STATUS_FINISHED': setGetTechStatusFinished,
    'SET_TECH_STATUS_WAITING': setTechStatusWaiting,
    'GET_TECH_STATUS_FAILED': setGetTechStatusFailed,
    'SET_TECH_STATUS_FINISHED': techStatusSetFinished,
    'SET_TECH_STATUS_FAILED': techStatusSetFailed,
    'WORK_ORDER_GET_TECH_ROUTE_STARTED': getTechRouteStarted,
    'WORK_ORDER_GET_TECH_ROUTE_FINISHED': getTechRouteFinished,
    'WORK_ORDER_GET_TECH_ROUTE_FAILED': getTechRouteFailed,
    'SET_ARRIVAL_TIME': setArrivalTime,
    'SET_PUBNUB_TOKEN': setPubNubToken,
    'redux-oidc/SESSION_TERMINATED': resetState,
    'redux-oidc/USER_FOUND': setTechInfoFromToken,
    'SET_TECH_SEARCH_PROPERTY': setSearchProperty,
    'SET_TECH_TRANSFER_TO_PROPERTY': setTransferToProperty,
    'SET_TECH_SEARCH_TOP_MATCH': setTopMatch,
    'persist/REHYDRATE': rehydrate,
    'SET_TECH_STATUS_READY': setStatusLoading,
    'SET_TECH_STATUS_IN_ROUTE': setStatusLoading,
    'SET_TECH_STATUS_ON_JOB': setStatusLoading,
    'SET_TECH_STATUS_UNDO_ON_JOB': setStatusLoading,
    'SET_TECH_STATUS_UNDO_IN_ROUTE': setStatusLoading,
    'SET_TECH_STATUS_ON_BREAK': setStatusLoading,
    'SET_TECH_STATUS_OFF_BREAK': setStatusLoading,
    'TECH_INVENTORY_GET_STARTED': setTechInventoryGetStarted,
    'TECH_INVENTORY_GET_FINISHED': setTechInventoryGetFinished,
    'TECH_INVENTORY_GET_FAILED': setTechInventoryGetFailed,
    'INVENTORY_SEARCH_STARTED': setInventorySearchStarted,
    'INVENTORY_SEARCH_FINISHED': setInventorySearchFinished,
    'INVENTORY_SEARCH_FAILED': setInventorySearchFailed,
    'SET_INVENTORY_SEARCH_VALUE': setInventorySearchValue,
    'INVENTORY_TRANSFER_STARTED': setInventoryTransferStarted,
    'INVENTORY_TRANSFER_FINISHED': setInventoryTransferFinished,
    'INVENTORY_TRANSFER_FAILED': setInventoryTransferFailed,
    'TECH_HISTORY_REQUEST_STARTED': techHistoryRequestStarted,
    'TECH_HISTORY_REQUEST_FINISHED': techHistoryRequestFinished,
    'TECH_HISTORY_REQUEST_FAILED': techHistoryRequestFailed,
    'SET_TECH_HISTORY_TECH_ID': setTechHistoryTechId,
    'SET_TECH_HISTORY_START_DATE': setTechHistoryStartDate,
    'SET_TECH_HISTORY_END_DATE': setTechHistoryEndDate
};

export default createReducer(initialState.get('techData'), handlers);



// WEBPACK FOOTER //
// ./src/reducers/techDataReducer.js